const prefix = 'jobStats/'

export const RESET_JOB_STATS_STATE = `${prefix}reset`
export const RESET_ENTITY_STATE = `${prefix}reset-entity`
export const SET_JOB_STATS_STATE = `${prefix}set`
export const GET_ALL_JOB_STATS = `${prefix}get-all-job-stat`
export const GET_SINGLE_JOB_STAT = `${prefix}get-single-job-stat`
